module.exports = __webpack_public_path__ + "static/media/Card_Temperature_fr.1eb81dfc.svg";